import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';

const VAL_INDICADOR_COMPLETO = "999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE = 'cs_id_699';

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Bienes Inmuebles', listHelp: ['750'] }

];

const tableStructure = [
  { id: 'desc', title: 'Descripción' },
  { id: 'valVenta', title: 'Valor' }
  
];

class Form1 {
  id: number;
  desc: string;
  valCompra: string;
  anioCompra: number;
  valDeclaradoAnioAnterior: string;
  aplicoArt73: string;
  valCatastral: string;
  valAjustadoArt73: string;
  valAjustadoArt70: string;
  art: number;
  ////////  Nuevos
  valLimiteImpPagExt: string;
  valVenta: string
  valMejoras: string;
  valImpuestoPag: string;
  valImpuestoCol: string;
  valCostoFiscal: string;
  valNacional: number;
  valAplicoArt73: string;
}

class ArticulosDominio {
  valor: number;
  nombre: string;
}

@Component({
  selector: 'app-ganancias-ocasionales-inmuebles-modal',
  templateUrl: './ganancias-ocasionales-inmuebles-modal.component.html',
  styleUrls: ['./ganancias-ocasionales-inmuebles-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class GananciasOcasionalesInmueblesModalComponent extends HandlerModal implements OnInit {

  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public lstArticulos: ArticulosDominio[] = [];
  public lstAnios: number[] = [];
  public lstSiNo: ArticulosDominio[] = [];

  public OPERACION_NULA: number = 0;
  public OPERACION_AGREGAR: number = 1;
  public OPERACION_EDITAR: number = 2;
  public OPERACION_BORRAR: number = 3;
  public operacionTabla: number = this.OPERACION_NULA;

  saveModel = new EventEmitter();
  public showSave: boolean;
  tablaArt73: any;

  constructor(
    public dutilidades: DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    public dialogRef: MatDialogRef<GananciasOcasionalesInmueblesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) {
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);

    console.log(model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
    this.validateShowSave();
    //this.reloadSelArticulos();
    this.initializeAnios();
    this.inicializarLista();
  }

  protected inicializeForm() {
    this.modelForm = new Form1();
    this.modelForm.id = 0;
    this.modelForm.desc = "";
    this.modelForm.valCompra = "0";
    this.modelForm.anioCompra = 0;
    this.modelForm.valDeclaradoAnioAnterior = "0";
    this.modelForm.valMejoras = "0";
    this.modelForm.valImpuestoPag= "0";
    this.modelForm.valImpuestoCol = "0";
    this.modelForm.valVenta = "0";
    this.modelForm.aplicoArt73 = "1";
    this.modelForm.valCatastral = "0";
    this.modelForm.valAjustadoArt73 = "0";    
    this.modelForm.art = 0;
    this.modelForm.valNacional = 1;
    this.reloadSelArticulos();
  }

  protected inicializeModelo() {

    if (this.model.doc.cuerpo.cc_id_711 == undefined || this.model.doc.cuerpo.cc_id_711.length == 0) {
      this.cleanAllValues();

    } else {
      if (!this.inconsistenciaCampos()) {

        console.log("ERROR ESTRUCTURA TABLA GO Inmuebles los campos de la tabla no están correctos. Se resetean datos de toda la tabla ");
        let i: number = 0;
        console.log("dato " + i + this.model.doc.cuerpo.cc_id_711); i = i + 1;
        console.log("dato " + i + this.model.doc.cuerpo.cc_id_187); i = i + 1;
        console.log("dato " + i + this.model.doc.cuerpo.cc_id_178); i = i + 1;
        console.log("dato " + i + this.model.doc.cuerpo.cc_id_179); i = i + 1;
        console.log("dato " + i + this.model.doc.cuerpo.cc_id_180); i = i + 1;
        console.log("dato " + i + this.model.doc.cuerpo.cc_id_186); i = i + 1;
        console.log("dato " + i + this.model.doc.cuerpo.cc_id_181); i = i + 1;
        console.log("dato " + i + this.model.doc.cuerpo.cc_id_182); i = i + 1;
        console.log("dato " + i + this.model.doc.cuerpo.cc_id_714); i = i + 1;
        console.log("dato " + i + this.model.doc.cuerpo.cc_id_188); i = i + 1;
        console.log("dato " + i + this.model.doc.cuerpo.cc_id_183); i = i + 1;
        console.log("dato " + i + this.model.doc.cuerpo.cc_id_185); i = i + 1;
        console.log("dato " + i + this.model.doc.cuerpo.cc_id_184); i = i + 1;
        console.log("dato " + i + this.model.doc.cuerpo.cc_id_193); i = i + 1;
        console.log("dato " + i + this.model.doc.cuerpo.cc_id_712); i = i + 1;

        this.cleanAllValues();
        this.model.doc.cuerpo.cs_id_765= "0";
        this.model.doc.cuerpo.cs_id_766="0";	
			  this.model.doc.cuerpo.cs_id_792="0";

      }
    }
    //this.model.doc.cuerpo.cc_id_712 = "0";  //?*?* pendiente totalizar 

  }

  protected cleanAllValues() {
    this.model.doc.cuerpo.cs_id_765 = "0";
    this.model.doc.cuerpo.cs_id_766 = "0";
    this.model.doc.cuerpo.cs_id_792 = "0";
    this.model.doc.cuerpo.cc_id_711 = [];
    this.model.doc.cuerpo.cc_id_187 = [];
    this.model.doc.cuerpo.cc_id_178 = [];
    this.model.doc.cuerpo.cc_id_179 = [];
    this.model.doc.cuerpo.cc_id_180 = [];
    this.model.doc.cuerpo.cc_id_186 = [];
    this.model.doc.cuerpo.cc_id_181 = [];
    this.model.doc.cuerpo.cc_id_182 = [];
    this.model.doc.cuerpo.cc_id_714 = [];
    this.model.doc.cuerpo.cc_id_188 = [];
    this.model.doc.cuerpo.cc_id_183 = [];
    this.model.doc.cuerpo.cc_id_185 = [];
    this.model.doc.cuerpo.cc_id_184 = [];
    this.model.doc.cuerpo.cc_id_193 = [];
    this.model.doc.cuerpo.cc_id_712 = [];
    this.model.doc.cuerpo.cs_id_699 = "0";//Indicador de Completo

  }





  public inconsistenciaCampos(): boolean {
    const longitud711: number = this.model.doc.cuerpo.cc_id_711.length;
    return this.validarContenido(this.model.doc.cuerpo.cc_id_187, longitud711) ||
      this.validarContenido(this.model.doc.cuerpo.cc_id_178, longitud711) ||
      this.validarContenido(this.model.doc.cuerpo.cc_id_179, longitud711) ||
      this.validarContenido(this.model.doc.cuerpo.cc_id_180, longitud711) ||
      this.validarContenido(this.model.doc.cuerpo.cc_id_186, longitud711) ||
      this.validarContenido(this.model.doc.cuerpo.cc_id_181, longitud711) ||
      this.validarContenido(this.model.doc.cuerpo.cc_id_182, longitud711) ||
      this.validarContenido(this.model.doc.cuerpo.cc_id_714, longitud711) ||
      this.validarContenido(this.model.doc.cuerpo.cc_id_188, longitud711) ||
      this.validarContenido(this.model.doc.cuerpo.cc_id_183, longitud711) ||
      this.validarContenido(this.model.doc.cuerpo.cc_id_185, longitud711) ||
      this.validarContenido(this.model.doc.cuerpo.cc_id_184, longitud711) ||
      this.validarContenido(this.model.doc.cuerpo.cc_id_193, longitud711) ||
      this.validarContenido(this.model.doc.cuerpo.cc_id_712, longitud711);

  }

  protected validarContenido(casComp: string[], longitud: number) {
    return (casComp != undefined && casComp != null && casComp.length == longitud);

  }
  protected reloadSelArticulos(conservarArt?: boolean) {//Dom 1649

    this.lstArticulos[0] = { valor: 0, nombre: "" };
    this.lstArticulos[1] = { valor: 1, nombre: "Valor Compra" };
    this.lstArticulos[2] = { valor: 2, nombre: "Valor avalúo año anterior" };
    this.lstArticulos[3] = { valor: 3, nombre: "Valor declarado año anterior" };
    this.lstArticulos[5] = { valor: 5, nombre: "Valor ajustado art. 73" };
   
      this.lstArticulos = [];
      let i = 0;
      this.lstArticulos[i] = { valor: 0, nombre: "" };
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.modelForm.valCompra.toString(), "0")) {
        i++;
        this.lstArticulos[i] = { valor: 1, nombre: ("Valor de compra: $" + this.modelForm.valCompra) };
      }
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.modelForm.valCatastral.toString(), "0")) {
        i++;
        this.lstArticulos[i] = { valor: 2, nombre: ("Valor de avalúo: $" + this.modelForm.valCatastral) };
      }
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.modelForm.valDeclaradoAnioAnterior.toString(), "0")) {
        i++;
        this.lstArticulos[i] = { valor: 3, nombre: ("Valor declarado año anterior: $" + this.modelForm.valDeclaradoAnioAnterior) };
      }
         if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.modelForm.valAjustadoArt73.toString(), "0")) {
        i++;
        this.lstArticulos[i] = { valor: 5, nombre: ("Valor ajustado art. 73: $" + this.modelForm.valAjustadoArt73) };
      }
    
    if (!conservarArt) this.modelForm.art = 0;
  }

  protected initializeAnios(){
    for(let i=0; i<this.tablaArt73.length;i++){
      if( Number(this.tablaArt73[i].anio) != 2020 &&
      Number(this.tablaArt73[i].anio) != 2021 && Number(this.tablaArt73[i].anio) != 2022 
   ){
      this.lstAnios[i]=Number(this.tablaArt73[i].anio);
      }
    }
  }
  protected inicializarLista() {
   
     
      this.lstSiNo[0] = {valor:1,nombre:"Si"};
      this.lstSiNo[1] = {valor:0,nombre:"No"};
  
  }


  public operacionCs765() {
    let suma1 = "0";
    let suma2 = "0";
    let suma3 = "0";
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      suma1 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valVenta, suma1);
      suma2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valCostoFiscal, suma2);
      suma3 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valLimiteImpPagExt, suma3);
    

    }
    this.model.doc.cuerpo.cs_id_765 = suma1;   //valor total venta 
    this.model.doc.cuerpo.cs_id_766 = suma2;   //valor total fiscal 
    this.model.doc.cuerpo.cs_id_792 = suma3;   //valor total venta 
  }

  public operaciones(numCas?: number, soloEstaCasilla?: boolean): void {
    switch (numCas) {
      case 158:
        this.operacionCS158();
        break;

    }
    if (soloEstaCasilla) return;

    //Operaciones
    let resultado = "0";

    this.reloadSelArticulos();

  }

  operacionCS158() {
    this.model.doc.cuerpo.cs_id_158 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_158, true);
  }


  //////////////////////
 /**  protected initializeArticulos() {
    this.lstUbicaciones[0] = { valor: 1, nombre: "Nacional" };
    this.lstUbicaciones[1] = { valor: 2, nombre: "Extranjero" };
    this.lstSiNo[0] = { valor: 1, nombre: "Si" };
    this.lstSiNo[1] = { valor: 1, nombre: "No" };

  }*/ 

 

  //////////////////////

  protected initializeTablaDesdeModelo() {
    this.dataSourceBody = [];
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_711.length; i++) {
      this.modelForm.id = i;
      this.modelForm.desc = this.model.doc.cuerpo.cc_id_711[i].v;
      this.modelForm.valVenta = this.model.doc.cuerpo.cc_id_178[i].v;
      this.modelForm.anioCompra = this.model.doc.cuerpo.cc_id_179[i].v;
      this.modelForm.valCompra = this.model.doc.cuerpo.cc_id_180[i].v;
      this.modelForm.valDeclaradoAnioAnterior = this.model.doc.cuerpo.cc_id_181[i].v;
      this.modelForm.valCatastral = this.model.doc.cuerpo.cc_id_182[i].v;
      this.modelForm.art=this.model.doc.cuerpo.cc_id_183[i].v;
      this.modelForm.valAjustadoArt73 = this.model.doc.cuerpo.cc_id_184[i].v; 
      this.modelForm.valMejoras = this.model.doc.cuerpo.cc_id_186[i].v; //nuevo
      this.modelForm.valImpuestoPag = this.model.doc.cuerpo.cc_id_188[i].v;
      this.modelForm.valLimiteImpPagExt = this.model.doc.cuerpo.cc_id_712[i].v;
      this.modelForm.valCostoFiscal = this.model.doc.cuerpo.cc_id_185[i].v;
      this.modelForm.valImpuestoCol = this.model.doc.cuerpo.cc_id_193[i].v;
      this.modelForm.valNacional = this.model.doc.cuerpo.cc_id_187[i].v;
      this.modelForm.valAplicoArt73 = this.model.doc.cuerpo.cc_id_714[i].v;



      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }

  public editModeloDesdeForm() {
    this.model.doc.cuerpo.cc_id_711[this.modelForm.id].v = this.modelForm.desc;
    this.model.doc.cuerpo.cc_id_178[this.modelForm.id].v = this.modelForm.valVenta.toString();
    this.model.doc.cuerpo.cc_id_179[this.modelForm.id].v = this.modelForm.anioCompra.toString();
    this.model.doc.cuerpo.cc_id_180[this.modelForm.id].v = this.modelForm.valCompra.toString();
    this.model.doc.cuerpo.cc_id_181[this.modelForm.id].v = this.modelForm.valDeclaradoAnioAnterior.toString();
    this.model.doc.cuerpo.cc_id_182[this.modelForm.id].v = this.modelForm.valCatastral.toString();
    this.model.doc.cuerpo.cc_id_183[this.modelForm.id].v = this.modelForm.art.toString();
    this.model.doc.cuerpo.cc_id_184[this.modelForm.id].v = this.modelForm.valAjustadoArt73.toString();
    this.model.doc.cuerpo.cc_id_186[this.modelForm.id].v = this.modelForm.valMejoras.toString();
    this.model.doc.cuerpo.cc_id_188[this.modelForm.id].v = this.modelForm.valImpuestoPag.toString();
    this.model.doc.cuerpo.cc_id_185[this.modelForm.id].v = this.modelForm.valCostoFiscal.toString();
    this.model.doc.cuerpo.cc_id_193[this.modelForm.id].v = this.modelForm.valImpuestoCol.toString();
    this.model.doc.cuerpo.cc_id_187[this.modelForm.id].v = this.modelForm.valNacional.toString();
    this.model.doc.cuerpo.cc_id_714[this.modelForm.id].v = this.modelForm.valAplicoArt73;
    this.model.doc.cuerpo.cc_id_712[this.modelForm.id].v = this.modelForm.valLimiteImpPagExt.toString();


  }

  public addToModeloDesdeForm() {
    let i = this.modelForm.id + 1;
    this.model.doc.cuerpo.cc_id_711.push({ it: i, v: this.modelForm.desc });
    this.model.doc.cuerpo.cc_id_178.push({ it: i, v: this.modelForm.valVenta.toString() });
    this.model.doc.cuerpo.cc_id_179.push({ it: i, v: this.modelForm.anioCompra.toString() });
    this.model.doc.cuerpo.cc_id_180.push({ it: i, v: this.modelForm.valCompra.toString() });
    this.model.doc.cuerpo.cc_id_181.push({ it: i, v: this.modelForm.valDeclaradoAnioAnterior.toString() });
    this.model.doc.cuerpo.cc_id_182.push({ it: i, v: this.modelForm.valCatastral.toString() });
    this.model.doc.cuerpo.cc_id_183.push({ it: i, v: this.modelForm.art.toString() });
    this.model.doc.cuerpo.cc_id_184.push({ it: i, v: this.modelForm.valAjustadoArt73.toString() });
    this.model.doc.cuerpo.cc_id_186.push({ it: i, v: this.modelForm.valMejoras.toString() });
    this.model.doc.cuerpo.cc_id_188.push({ it: i, v: this.modelForm.valImpuestoPag.toString() });
    this.model.doc.cuerpo.cc_id_185.push({ it: i, v: this.modelForm.valCostoFiscal.toString() });
    this.model.doc.cuerpo.cc_id_193.push({ it: i, v: this.modelForm.valImpuestoCol.toString() });
    this.model.doc.cuerpo.cc_id_187.push({ it: i, v: this.modelForm.valNacional });
    this.model.doc.cuerpo.cc_id_714.push({ it: i, v: this.modelForm.valAplicoArt73 });
    this.model.doc.cuerpo.cc_id_712.push({ it: i, v: this.modelForm.valLimiteImpPagExt.toString() });

  }

  public deleteOnModel(index: number) {
    this.model.doc.cuerpo.cc_id_711.splice(index, 1);
    this.model.doc.cuerpo.cc_id_178.splice(index, 1);
    this.model.doc.cuerpo.cc_id_179.splice(index, 1);
    this.model.doc.cuerpo.cc_id_180.splice(index, 1);
    this.model.doc.cuerpo.cc_id_181.splice(index, 1);
    this.model.doc.cuerpo.cc_id_182.splice(index, 1);
    this.model.doc.cuerpo.cc_id_183.splice(index, 1);
    this.model.doc.cuerpo.cc_id_184.splice(index, 1);
    this.model.doc.cuerpo.cc_id_186.splice(index, 1);
    this.model.doc.cuerpo.cc_id_188.splice(index, 1);
    this.model.doc.cuerpo.cc_id_712.splice(index, 1);
    this.model.doc.cuerpo.cc_id_185.splice(index, 1);
    this.model.doc.cuerpo.cc_id_193.splice(index, 1);
    this.model.doc.cuerpo.cc_id_187.splice(index, 1);
    this.model.doc.cuerpo.cc_id_714.splice(index, 1);



    //reenumerear it
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_711.length; i++) {
      this.model.doc.cuerpo.cc_id_711[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_178[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_184[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_179[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_181[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_182[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_184[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_183[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_186[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_188[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_180[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_712[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_714[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_187[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_185[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_193[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_185[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_193[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_187[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_714[i].it = i + 1;

    }
  }

  public validateFormCompleted(): boolean {

    console.log('Valores Formulario detalle: desc: ' + this.modelForm.desc + ' valVenta: ' + this.modelForm.valVenta +
      ' anioCompra: ' + this.modelForm.anioCompra + ' valCompra: ' + this.modelForm.valCompra +
      ' valDeclaradoAnioAnterior: ' + this.modelForm.valDeclaradoAnioAnterior + ' valAvaluo : ' +
      this.modelForm.valCatastral + ' valAjustadoArt73: '
    + this.modelForm.valAjustadoArt73  //+ this.modelForm.ubicacion+   **mod
    );



    return this.modelForm.desc == undefined || this.modelForm.desc == "" ||
      this.modelForm.valVenta == undefined || this.modelForm.valVenta == "0" ||
      this.modelForm.anioCompra == undefined || this.modelForm.anioCompra == 0 ||
      this.modelForm.valCompra == undefined || this.modelForm.valCompra == "0" ||
      this.modelForm.valVenta == undefined || this.modelForm.valVenta == "0" ||
      this.modelForm.valDeclaradoAnioAnterior == undefined || this.modelForm.valDeclaradoAnioAnterior == "0"||
      this.modelForm.valCatastral == undefined || this.modelForm.valCatastral == "0"||
      //this.modelForm.ubicacion == undefined || this.modelForm.ubicacion == "0" ||
      this.modelForm.valAjustadoArt73 == undefined || this.modelForm.valAjustadoArt73 == "0"  ||
      Number(this.modelForm.art) == undefined || Number(this.modelForm.art) == 0 
      //this.modelForm.valMejoras ==undefined || this.modelForm.valMejoras == "0"  //||
      //this.modelForm.valImpuestoPag ==undefined || this.modelForm.valImpuestoPag ==0  //||
      //this.modelForm.valDeclarar==undefined || this.modelForm.valDeclarar==""
      ;
  }

   public redondearFormData() {
    this.modelForm.valCompra=this.dutilidades.redondearValorMoneda(this.modelForm.valCompra.toString(),true);
    this.modelForm.valDeclaradoAnioAnterior=this.dutilidades.redondearValorMoneda(this.modelForm.valDeclaradoAnioAnterior.toString(),true);
    this.modelForm.valVenta=this.dutilidades.redondearValorMoneda(this.modelForm.valVenta.toString(),true);
    this.modelForm.valCatastral=this.dutilidades.redondearValorMoneda(this.modelForm.valCatastral.toString(),true);
    this.modelForm.valImpuestoPag =this.dutilidades.redondearValorMoneda(this.modelForm.valImpuestoPag.toString(),true);
    this.modelForm.valMejoras =this.dutilidades.redondearValorMoneda(this.modelForm.valMejoras.toString(),true);
   
   }

   //limite impuesto pagado en colombia
OperacionCsLimiteImp(valImp:string,valVenta:string,costoFiscal:string){
	 valImp = this.dutilidades.redondearValorMoneda(valImp);	
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,valImp,"0")) {
		
		//const cas178 = this.model.doc.cuerpo.cs_id_178; //valVenta
		//const cas185 = this.model.doc.cuerpo.cs_id_185; //costoFiscal
		
		let resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA,valVenta,costoFiscal);
		if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,resultado,"0")) {
			resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,resultado,"0.1");
      this.modelForm.valImpuestoCol = resultado;
			if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,valImp,resultado)) {
				this.modelForm.valLimiteImpPagExt = resultado;
			} else {
				this.modelForm.valLimiteImpPagExt= valImp;
			}			
		} else {
      this.modelForm.valLimiteImpPagExt = "0";
      this.modelForm.valImpuestoCol = "0";
		}
	}
}

   public calcularValoresForm(conservarArt?:boolean){
    this.redondearFormData();
    if(this.modelForm.valNacional== 1){
      this.modelForm.valImpuestoCol = "0";
      this.modelForm.valImpuestoPag = "0";
      this.modelForm.valLimiteImpPagExt = "0";
    }
    
    //this.modelForm.valAjustadoArt70 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,this.modelForm.valDeclaradoAnioAnterior.toString(), "1.0467",true);
    //this.modelForm.valAjustadoArt70 = this.dutilidades.redondearValorMoneda(this.modelForm.valAjustadoArt70.toString(),true);
    if(this.modelForm.aplicoArt73=="1"){
      let registroArt73 = this.tablaArt73.find((ite: any) => this.modelForm.anioCompra == ite.anio);
      let resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,this.modelForm.valCompra.toString(), registroArt73.bienes.toString(),false);
      this.modelForm.valAjustadoArt73 = resultado;
      this.modelForm.valAjustadoArt73 = this.dutilidades.redondearValorMoneda(this.modelForm.valAjustadoArt73.toString(),true);
      //this.modelForm.valAjustadoArt73 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,this.modelForm.valAjustadoArt73.toString(), "0.001",false);
      this.modelForm.valAjustadoArt73 = this.dutilidades.redondearValorMoneda(this.modelForm.valAjustadoArt73.toString(),true);
     
      
    }else{
      this.modelForm.valAjustadoArt73 = "0";
    }
    this.modelForm.valAjustadoArt73 = this.dutilidades.redondearValorMoneda(this.modelForm.valAjustadoArt73.toString(),true);
    let valDeclarar = "0";
    switch(Number(this.modelForm.art)){
      case 1:
        valDeclarar = this.modelForm.valCompra.toString();
        
        break;
      case 2:
        valDeclarar = this.modelForm.valCatastral.toString();
        break;
      case 3:
        valDeclarar = this.modelForm.valDeclaradoAnioAnterior.toString();
        break;
      case 4:
        valDeclarar = this.modelForm.valAjustadoArt70.toString();
        break;
      case 5:
        valDeclarar = this.modelForm.valAjustadoArt73.toString();
        break;  
      default:
        valDeclarar = "0";      
    }
    
    this.modelForm.valCostoFiscal =  this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.modelForm.valMejoras.toString(),valDeclarar  ,false);
    this.modelForm.valCostoFiscal = this.dutilidades.redondearValorMoneda(this.modelForm.valCostoFiscal.toString(),true);
   
    
    if (this.modelForm.valNacional == 0){ //Calcula limite de Immp
      this.OperacionCsLimiteImp(this.modelForm.valImpuestoPag,this.modelForm.valVenta,this.modelForm.valCostoFiscal)
    }
    
    this.reloadSelArticulos(conservarArt);
  }
  saveItem(): void {
    if(this.validateFormCompleted()){
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro" );
      return;
    }else{
      this.redondearFormData();
      if (this.operacionTabla==this.OPERACION_EDITAR){
        this.editModeloDesdeForm();
      }else if (this.operacionTabla==this.OPERACION_AGREGAR){
        this.modelForm.id = this.dataSourceBody.length;
        this.dataSourceBody.push(this.modelForm);
        this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs765();
      this.inicializeForm();
      this.operacionTabla=this.OPERACION_NULA;
      console.log(this.model);
    }
  }

  eventTable($event: string): void {
    if($event === 'add') this.operacionTabla=this.OPERACION_AGREGAR;
    if($event === 'edit') this.operacionTabla=this.OPERACION_EDITAR;
    if($event === 'delete') this.operacionTabla=this.OPERACION_BORRAR;
    this.operacionCs765();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if(this.operacionTabla==this.OPERACION_EDITAR){//editando
      this.modelForm = this.dataSourceBody[index];
      this.reloadSelArticulos(true);
    }
    if(this.operacionTabla==this.OPERACION_BORRAR){//borrando
      this.deleteOnModel(index);
      this.operacionTabla=this.OPERACION_NULA;
      console.log(this.model);
    }
  }
  
  cancel(): void {
    this.inicializeForm();
    this.operacionTabla=this.OPERACION_NULA;
  }

  
  ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO
  public validateRbQuestions(val: string) {
    this.modelForm.aplicoArt73 = val;
    this.calcularValoresForm();
  }
  
  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    
  }
  
  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS:number):boolean{
    let habilitado = true;
    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive(){

  }

  //////////////////////////
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  protected updateIndicadorAvance(){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(this.indexStepper> Number(casIndicadorAvance)){
      let indexS = this.indexStepper+1;
      while(!this.validateStepHabilitado(indexS)){
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=indexS.toString();
    }
    if(this.indexStepper==this.stepsList.length-1){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
    }
  }


  protected controlStep(direction: DirectionType): void {
    this.changeStepLocal(this.indexStepper, true);
  }

  public changeStepLocal(index: number, forceUpdateStepper?:boolean){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(forceUpdateStepper){
      this.changeStep(index);
      this.updateIndicadorAvance();
    }else if(this.validateStepHabilitado(index)){
      let indexCalc = index-1;
      if(indexCalc<=Number(casIndicadorAvance)){
        this.changeStep(index);
        this.updateIndicadorAvance();
      }else{
        console.log("Avance no permitido: casIndicadorAvance=" + casIndicadorAvance + ", index-1="+(indexCalc));
      }
    }
    this.validateBtnRightActive();
    this.validateShowSave();
  }
  
  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ this.showSave=true };
  }

  public closeModal(){
    this.changeStepLocal(0);
    this.dialogRef.close("");
  }
  public guardar(){
    this.saveModel.emit(true);
    if(this.indexStepper==this.stepsList.length-1){
      this.closeModal();
    }
  }
  public borrarTabla(){
    this.dataSourceBody = [];
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/ganancias-ocasionales/ganancias-ocasionales-inmuebles-modal/ganancias-ocasionales-inmuebles-modal.component.ts